<div class="modal-header">
    <h5 class="pt-4" style="padding-left:2rem">Movimiento de inventario</h5>
    <button type="button" class="btn-close me-4" mat-dialog-close></button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content class="scroll-modal">
  
    <div class="row mb-1">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100 custom-field">
          <mat-label>Tipo de movimiento</mat-label>
          <mat-select [(ngModel)]="tipoMovimiento" (selectionChange)="changeTipoMovimiento($event)">
            <mat-option value="linea">
              Mover material de una línea a otra
            </mat-option>
            <mat-option value="inv">
              Devolver sobrante al inventario
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Cuando escoja mover de una linea a otra-->
    <div *ngIf="tipoMovimiento == 'linea' ">
      <div class="row mb-1">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>Línea origen</mat-label>
            <mat-select [(ngModel)]="lineaOrigen" (selectionChange)="changeLineaOrigen($event)">
              <mat-option *ngFor="let linea of dataMat.lineas" [value]="linea.line">Línea {{linea.line}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field" floatLabel="always">
            <mat-label>Línea destino</mat-label>
            <mat-select [(ngModel)]="lineaDestino" (selectionChange)="changeLineaDestino($event)">
              <mat-option *ngFor="let linea of dataMat.lineas" [value]="linea.line">Línea {{linea.line}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>Estación origen</mat-label>
            <mat-select [(ngModel)]="estacionOrigen" (selectionChange)="changeEstacionOrigen($event)">
              <mat-option value="all">Todas las estaciones</mat-option>
              <mat-option *ngFor="let est of estacionesOrigen" [value]="est.estacion">{{est.estacion}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>Estación destino</mat-label>
            <mat-select [(ngModel)]="estacionDestino" (selectionChange)="changeEstacionDestino($event)">
              <mat-option value="all">Todas las estaciones</mat-option>
              <mat-option *ngFor="let est of estacionesDestino" [value]="est.estacion">{{est.estacion}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="tipoMovimiento == 'inv' ">
      <div class="row mb-1">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>Línea</mat-label>
            <mat-select [(ngModel)]="lineaInv" (selectionChange)="changeLineaInv($event)">
              <mat-option *ngFor="let linea of dataMat.lineas" [value]="linea.line">Línea {{linea.line}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>Estación</mat-label>
            <mat-select [(ngModel)]="estacionInv" (selectionChange)="changeEstacionInv($event)">
              <mat-option value="all">Todas las estaciones</mat-option>
              <mat-option *ngFor="let est of estacionesInv" [value]="est.estacion">{{est.estacion}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>



  <h6 class="fw-bold mb-1">Materiales</h6>

  <div class="row mb-1">
    <div class="col-md-4">
        <div class="input-group input-group-sm search-input">
            <span class="input-group-text bg-white border-end-0">
                <mat-icon class="text-muted icon-sm">search</mat-icon>
            </span>
            <input
                type="text"
                class="form-control border-start-0"
                placeholder="Buscar"
                (keyup)="filtrarMateriales($event)"
            >
        </div>
    </div>
  </div>

  <div class="table-responsive table-wrapper">
    <table mat-table [dataSource]="materialesFiltrados" class="mat-elevation-z1 w-100 tblMateriales">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="isAllSelected()"
            [indeterminate]="isIndeterminate()"
            (change)="toggleAll($event)">
            
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [(ngModel)]="row.selected"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef>Material</th>
        <td mat-cell *matCellDef="let row">{{ row.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="origen">
        <th mat-header-cell *matHeaderCellDef>{{ tituloOrigen }}</th>
        <td mat-cell *matCellDef="let row">{{ row.cantidadOrigen }}</td>
      </ng-container>

      <ng-container matColumnDef="destino">
        <th mat-header-cell *matHeaderCellDef>Cantidad destino</th>
        <td mat-cell *matCellDef="let row">{{ row.cantidadDestino }}</td>
      </ng-container>

      <ng-container matColumnDef="transferir">
        <th mat-header-cell *matHeaderCellDef>Transferir</th>
        <td mat-cell *matCellDef="let row">
          <mat-form-field appearance="outline" class="w-100 inp-transf">
            <input matInput type="number" [(ngModel)]="row.transferir">
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnas"></tr>
      <tr mat-row *matRowDef="let row; columns: columnas;"></tr>

    </table>
  </div>
  
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-4">
    <button mat-flat-button class="bg-success text-white ms-5" (click)="saveMovimiento()" type="button">Guardar</button>
</mat-dialog-actions>

